// some library check React version
// see: https://github.com/NervJS/nerv/issues/46
export const version = '15.4.2'
